import React, { useEffect, useRef, useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Box from "@mui/material/Box";
import { GridColDef, GridPinnedColumnFields } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import {
    IconButton,
    TextField,
    MenuItem,
    Menu,
    Stack,
    Tooltip,
    Drawer,
    Button,
    Alert
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import Grid from "@mui/material/Grid2";
import Chip from "@mui/material/Chip";
import { ThreeDot } from "react-loading-indicators";
import emptyImage from "../../assets/images/image.png";
import { DataGridPro } from "@mui/x-data-grid-pro";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
    getAllMmrfq,
    getAutoPopulateCoRFQDetailsForMMRFQApi,
    sendReminderToSourcingHeadAPI,
    sendToKamTriggerAPI
} from "../Services/MMRfqForm";
import PartnerDetailsDrawer from "../../Sourcing/Partner/PartnerDetails/PartnerDetailsDrawer";
import { QuoteDrawer } from "./QuoteDrawer";
import {
    getLoggedInName,
    getLoggedInUserDepartment,
    getLoggedInUserID,
    isManagement,
    LoggedInUserDepartment,
    NPDManager,
    NPDManagerHead,
    productionManager,
    productionManagerHead,
    sourcingManager,
    sourcingManagerHead
} from "../../Utils/Constant";
import { setMmRfqFormData } from "../../Redux/MMRfq/actions";
import { useDispatch } from "react-redux";
import { showToast } from "../../Components/Toast";
import PriorityHighOutlinedIcon from "@mui/icons-material/PriorityHighOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import dayjs from "dayjs";

type Quote = {
    Quote_ID: string;
    ID: string;
    status: string;
};

export const AllMmrfq = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [rows, setRows] = useState<any[]>([]);
    const [filteredRows, setFilteredRows] = useState(rows);
    const [anchorEl, setAnchorEl] = useState(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const searchInputRef = useRef<HTMLInputElement>(null);
    const [isAllPartQuoteApproved, setIsAllPartQuoteApproved] =
        useState<boolean>(false);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [selectedPartnerRow, setSelectedPartnerRow] = useState(null);
    const [isButtonDisable, setIsButtonDisable] = useState(false);
    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 10 // Default page size
    });
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectedQuoteId, setSelectedQuoteId] = useState(null);
    const handleQuoteIdClick = (id) => {
        setSelectedQuoteId(id);
        setDrawerOpen(true);
    };

    const [isDropped, setIsDropped] = useState(false);
    // const navigate = useNavigate();
    // const coRFQId = location.state?.rfqData;
    // const { rfqData, from } = location.state || {};
    // const from = location?.state?.from || "AllMmrfq";
    const location = useLocation();
    const { coRFQId, from } = React.useMemo(() => {
        const storedData = JSON.parse(
            localStorage.getItem("AllMmrfq") || "null"
        );
        return {
            coRFQId: location.state?.rfqData || storedData?.rfqData,
            from: location?.state?.from || storedData?.from
        };
    }, [location.state]);

    const navigate = useNavigate();
    const [pinnedColumns, setPinnedColumns] =
        React.useState<GridPinnedColumnFields>({
            left: ["MMRFQ_ID", "Part_Number"],
            right: ["action"]
        });
    const handlePinnedColumnsChange = React.useCallback(
        (updatedPinnedColumns: GridPinnedColumnFields) => {
            setPinnedColumns(updatedPinnedColumns);
        },
        []
    );
    const handleCloseDrawer = () => {
        setOpenDrawer(false);
    };

    const fetchCustomerRfqData = async (payload) => {
        setIsLoading(true);
        try {
            const response = await getAllMmrfq(payload);

            if (response?.status) {
                const transformedData = (data) => {
                    setIsDropped(data[0]?.Is_CoRfq_Dropped);
                    const result = [];
                    data?.forEach((rfq, index) => {
                        rfq?.Part_Details.forEach((part, partIndex) => {
                            result.push({
                                id: `${index}-${partIndex}`,
                                showGroup: partIndex === 0,
                                MMRFQ_ID: rfq?.MMRFQ_ID,
                                ID: rfq?.ID,
                                MM_RFQ_Name: rfq?.MM_RFQ_Name || "-",
                                Quote_IDs: Array.isArray(part?.Quote_IDs)
                                    ? part?.Quote_IDs
                                    : [],
                                Timeline: rfq?.Timeline || "-",
                                Start_Date: part?.Start_Date,
                                Due_Date: part?.Due_Date,
                                Rfq_End_Date: rfq?.Rfq_End_Date,
                                partnersRequested:
                                    part?.Partner_Quotes_Requested || 0,
                                partnersReceived:
                                    part?.Partner_Quotes_Received || 0,
                                Part_Name: part?.Part_Name || "-",
                                Part_Number: part?.Part_Number || "-",
                                selectPartners: part?.Select_Partners || [],
                                Part_Row_ID: part?.Part_Row_ID || "-",
                                Status: part?.Status || "-",
                                Kam_Name: rfq?.Kam_Name || "-",
                                Is_Sent_To_Kam: rfq?.Is_Sent_To_Kam,
                                Org_Due_Date: rfq?.Org_Due_Date,
                                Ready_For_Proposal_Time:
                                    rfq?.Ready_For_Proposal_Time
                            });
                        });
                    });

                    return result;
                };
                const data = transformedData(response?.data);
                setRows(data);
                setFilteredRows(data);

                // ✅ NEW: check if ALL MMRFQs are ready for KAM
                const checkAllMmrfqsReadyForKam = (rows) => {
                    const grouped: Record<string, Quote[]> = {};

                    rows.forEach((item) => {
                        const mmrfqId = item.MMRFQ_ID;
                        if (!grouped[mmrfqId]) grouped[mmrfqId] = [];
                        grouped[mmrfqId].push(...(item.Quote_IDs || []));
                    });

                    return Object.values(grouped).every((quotes) => {
                        const hasApproved = quotes.some(
                            (q) => q.status === "Approved"
                        );
                        const hasRejected = quotes.some(
                            (q) => q.status === "Rejected"
                        );
                        const hasPending = quotes.some(
                            (q) => q.status === "Pending"
                        );
                        return hasApproved && hasRejected && !hasPending;
                    });
                };

                const allReady = checkAllMmrfqsReadyForKam(data);
                setIsAllPartQuoteApproved(allReady);
            } else {
                setRows([]);
                setFilteredRows([]);
                setIsAllPartQuoteApproved(false);
            }
        } catch (error) {
            console.error("Error fetching RFQ data:", error);
            setRows([]);
            setFilteredRows([]);
            setIsAllPartQuoteApproved(false);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (coRFQId?.ID) {
            fetchCustomerRfqData(coRFQId?.ID);
        }
        setAnchorEl(null);
    }, [coRFQId]);
    // Handle search input change
    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const search = event?.target?.value;
        setSearchTerm(search);
        if (search?.length >= 3) {
            const filtered = rows?.filter((row) =>
                ["MMRFQ_ID", "Part_Name"].some(
                    (key) =>
                        typeof row[key] === "string" &&
                        row[key].toLowerCase().includes(search.toLowerCase())
                )
            );
            setFilteredRows(filtered);
        } else {
            setFilteredRows(rows);
        }
    };

    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [searchTerm]);
    type Partner = {
        ID: string;
        Legal_Name_of_Business: string;
        zc_display_value: string;
        status: string;
    };
    const PartnerInvolved = ({ value }: { value?: Partner[] }) => {
        const [expanded, setExpanded] = useState(false);
        // const partners = value || [];
        const partners = (value || []).sort((a, b) => {
            // Approved status first
            if (a.status === "Approved" && b.status !== "Approved") return -1;
            if (a.status !== "Approved" && b.status === "Approved") return 1;
            return 0;
        });

        const displayedPartners = expanded ? partners : partners.slice(0, 2);
        const remainingCount = partners.length - 2;
        const handlePartnerChip = (data) => {
            let obj = {
                unique_ID: data?.ID,
                navigatingFrom: "All MMRFQs",
                ID: coRFQId?.ID,
                rfqID: coRFQId?.rfqID
            };
            setSelectedPartnerRow(obj);
            setOpenDrawer(true);
        };

        return (
            <Box
                sx={{
                    gap: 0,
                    alignItems: "center",
                    height: "100%",
                    padding: "5px 0 5px",
                    display: "flex",
                    flexWrap: "wrap"
                }}
            >
                {displayedPartners?.map((partner, idx) => (
                    <Chip
                        key={partner?.ID || idx}
                        label={
                            partner?.zc_display_value ||
                            partner?.Legal_Name_of_Business
                        }
                        size="small"
                        sx={{
                            margin: "2px 0px 0px 5px",
                            background:
                                partner?.status === "Approved" ? " #FFECB3" : ""
                        }}
                        onClick={() => handlePartnerChip(partner)}
                    />
                ))}

                {!expanded && remainingCount > 0 && (
                    <Chip
                        size="small"
                        label={`+${remainingCount}`}
                        sx={{ cursor: "pointer", margin: "2px 0px 0px 5px" }}
                        onClick={() => setExpanded(true)}
                    />
                )}
                {expanded && (
                    <IconButton
                        size="small"
                        onClick={() => setExpanded(false)}
                        sx={{ margin: "2px 0px 0px 5px" }}
                    >
                        <CancelIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>
        );
    };

    const columns: GridColDef[] = [
        {
            field: "MMRFQ_ID",
            headerName: "MMRFQ ID",
            width: 125,
            disableColumnMenu: true,
            cellClassName: (params) => {
                return params.row.showGroup ? "" : "hide-top-border";
            },
            renderCell: (params) => {
                // console.log(
                //   "thisMMRFQ_ID",
                //   thisMMRFQ_ID,
                //   "showgroup",
                //   params?.row?.showGroup
                // );
                // console.log(
                //   "duedate",
                //   params?.row?.Due_Date,
                //   "rfqenddate",
                //   params?.row?.Org_Due_Date
                // );
                const thisMMRFQ_ID = params?.row?.MMRFQ_ID;
                // Find all rows with this MMRFQ_ID:
                const partsForThisMMRFQ = rows.filter(
                    (r) => r.MMRFQ_ID === thisMMRFQ_ID
                );

                const anyDueDateChanged = partsForThisMMRFQ.some(
                    (p) => p.Due_Date !== p.Org_Due_Date
                );
                return params?.row?.showGroup ? (
                    <>
                        <div
                            style={{
                                display: "block",
                                wordBreak: "break-word"
                            }}
                        >
                            <Link
                                to="/layout/MmrfqDetails"
                                style={{ textDecoration: "none" }}
                                state={{
                                    rfqData: {
                                        ID: coRFQId?.ID,
                                        rfqID: coRFQId?.rfqID,
                                        mmRfqId: params?.row?.MMRFQ_ID,
                                        mmRfqRowId: params?.row?.ID,
                                        Part_Row_ID: params?.row?.Part_Row_ID,
                                        Part_Number: params?.row?.Part_Number,
                                        Partner_ID: params?.row?.Partner_ID
                                    },
                                    from: from
                                }}
                            >
                                <Chip
                                    size="small"
                                    label={params?.value}
                                    sx={{ marginBottom: "5px" }}
                                />
                            </Link>
                            <Typography
                                variant="subtitle2"
                                color="text.secondary"
                                sx={{ fontSize: "0.65rem" }}
                            >
                                {(params?.row?.Due_Date !==
                                    params?.row?.Org_Due_Date ||
                                    anyDueDateChanged) &&
                                    `${params?.row?.Org_Due_Date} (Orig. due date)`}
                            </Typography>
                        </div>
                    </>
                ) : (
                    ""
                );
            }
        },

        {
            field: "Part_Number",
            headerName: "Part Number",
            width: 130,
            disableColumnMenu: true,
            renderCell: (params) => {
                const quoteStatuses = params.row?.Quote_IDs || [];
                const hasVerdictPending =
                    quoteStatuses.some((q) => q.status === "Pending") &&
                    quoteStatuses.some((q) => q.status !== "Approved") &&
                    quoteStatuses.some((q) => q.status !== "Rejected");
                return (
                    <div style={{ display: "block", wordBreak: "break-word" }}>
                        {params?.value}
                        {hasVerdictPending === true && (
                            <Typography
                                variant="subtitle2"
                                style={{
                                    fontSize: "0.65rem",
                                    display: "flex",
                                    alignItems: "center"
                                }}
                            >
                                <ErrorOutlineOutlinedIcon
                                    color="error"
                                    style={{
                                        fontSize: "0.70rem",
                                        marginRight: 4
                                    }}
                                />
                                <span style={{ color: "#0009" }}>
                                    Verdict Pending
                                </span>
                            </Typography>
                        )}
                    </div>
                );
            }
        },
        {
            field: "Part_Name",
            headerName: "Part Name",
            width: 150,
            disableColumnMenu: true
        },
        {
            field: "Timeline",
            headerName: "Timeline",
            width: 180,
            disableColumnMenu: true,
            renderCell: (params) => {
                const chipLabel =
                    params?.row?.Status !== "Pending"
                        ? "Closed"
                        : params?.value;
                const showIcon =
                    typeof chipLabel === "string" &&
                    chipLabel.includes("overdue");

                return (
                    <>
                        <Chip label={chipLabel} size="small"></Chip>
                        {showIcon && (
                            <ErrorOutlineOutlinedIcon
                                sx={{ fontSize: "1.2rem", marginLeft: "5px" }}
                                color="error"
                            />
                        )}
                    </>
                );
            }
        },
        {
            field: "Quote_IDs",
            headerName: "Quote ID",
            width: 200,
            disableColumnMenu: true,
            renderCell: (params) => {
                if (!Array.isArray(params.value) || params.value.length === 0) {
                    return (
                        <Chip
                            color="primary"
                            label="Yet to Create"
                            variant="outlined"
                            size="small"
                        />
                    );
                }
                return (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                        {params.value.map((item, index) => (
                            <Chip
                                key={index}
                                label={item?.Quote_ID}
                                onClick={() => handleQuoteIdClick(item?.ID)}
                                size="small"
                                sx={{
                                    cursor: "pointer",
                                    margin: "2px 0px 0px 5px",
                                    background:
                                        item?.status === "Approved"
                                            ? " #FFECB3"
                                            : ""
                                }}
                            />
                        ))}
                    </div>
                );
            }
        },
        {
            field: "selectPartners",
            headerName: "Partners Involved",
            width: 300,
            disableColumnMenu: true,
            renderCell: (params) => <PartnerInvolved value={params.value} />
        },

        {
            field: "Start_Date",
            headerName: "MMRFQ Start Date",
            width: 150,
            disableColumnMenu: true
        },
        {
            field: "Due_Date",
            headerName: "MMRFQ End Date",
            width: 150,
            disableColumnMenu: true
        },
        {
            field: "partnersRequested",
            headerName: "Quotes Requested",
            width: 150,
            disableColumnMenu: true
        },
        {
            field: "partnersReceived",
            headerName: "Quotes Received",
            width: 150,
            disableColumnMenu: true
        },

        {
            field: "action",
            headerName: "Action",
            width: 158,
            disableColumnMenu: true,
            cellClassName: () => "first-pinned-right",
            headerClassName: "first-pinned-right",
            renderCell: (params) => {
                const isDisabled = params?.row?.partnersReceived < 2;
                return (
                    <>
                        <Box
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center"
                                }}
                            >
                                {params?.row?.Status === "Pending" ? (
                                    <Link
                                        to="/layout/QuoteCompareData"
                                        style={{
                                            pointerEvents: isDisabled
                                                ? "none"
                                                : "auto",
                                            textDecoration: "none",
                                            color: isDisabled
                                                ? "#ccc"
                                                : "#0070BA"
                                        }}
                                        onClick={(e) => {
                                            if (isDisabled) {
                                                e.preventDefault();
                                            }
                                        }}
                                        state={{
                                            rfqData: {
                                                ID: coRFQId?.ID,
                                                rfqID: coRFQId?.rfqID,
                                                mmRfqId: params?.row?.MMRFQ_ID,
                                                mmRfqRowId: params?.row?.ID,
                                                Part_Row_ID:
                                                    params?.row?.Part_Row_ID,
                                                Part_Number:
                                                    params?.row?.Part_Number,
                                                Partner_ID:
                                                    params?.row?.Partner_ID
                                            },
                                            from: from
                                        }}
                                    >
                                        Compare Quotes
                                    </Link>
                                ) : (
                                    <Link
                                        to="/layout/QuoteCompareData"
                                        style={{
                                            pointerEvents: isDisabled
                                                ? "none"
                                                : "auto",
                                            textDecoration: "none",
                                            color: isDisabled
                                                ? "#ccc"
                                                : "#0070BA"
                                        }}
                                        onClick={(e) => {
                                            if (isDisabled) {
                                                e.preventDefault();
                                            }
                                        }}
                                        state={{
                                            rfqData: {
                                                ID: coRFQId?.ID,
                                                rfqID: coRFQId?.rfqID,
                                                mmRfqId: params?.row?.MMRFQ_ID,
                                                mmRfqRowId: params?.row?.ID,
                                                Part_Row_ID:
                                                    params?.row?.Part_Row_ID,
                                                Part_Number:
                                                    params?.row?.Part_Number,
                                                Partner_ID:
                                                    params?.row?.Partner_ID
                                            },
                                            from: from
                                        }}
                                    >
                                        View Quotes
                                    </Link>
                                )}
                                {isDisabled && (
                                    <Tooltip title="Minimum 2 quotes required">
                                        <IconButton>
                                            <InfoOutlinedIcon
                                                sx={{
                                                    width: "20px",
                                                    height: "20px"
                                                }}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </div>
                            <div>
                                <ActionMenu params={params?.row} />
                            </div>
                        </Box>
                    </>
                );
            }
        }
    ];
    const ActionMenu = ({ params }) => {
        const [anchorEl, setAnchorEl] = useState(null);
        const [isButtonDisable, setIsButtonDisable] = useState(false);
        const open = Boolean(anchorEl);
        const dispatch = useDispatch();
        const navigate = useNavigate();

        const today = new Date();

        const monthNames = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ];

        const parseDate = (dateStr) => {
            if (!dateStr) return null;
            const [day, monthStr, year] = dateStr.split("-");
            const monthIndex = monthNames.indexOf(monthStr);
            return new Date(year, monthIndex, parseInt(day));
        };

        const dueDate = parseDate(params?.Due_Date);
        const rfqEndDate = parseDate(params?.Rfq_End_Date);

        const todayDateOnly = new Date();
        todayDateOnly.setHours(0, 0, 0, 0);

        const dueDateOnly = dueDate ? new Date(dueDate) : null;
        if (dueDateOnly) {
            dueDateOnly.setHours(0, 0, 0, 0);
        }
        // const orgDueDate = params?.Rfq_End_Date;

        const isDisabled =
            params?.partnersRequested === params?.partnersReceived ||
            (dueDateOnly && dueDateOnly < todayDateOnly);

        const handleClick = (event) => {
            setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
            setAnchorEl(null);
        };

        const handleCallMMRFQApi = async (fromPath) => {
            dispatch(setMmRfqFormData([]));
            try {
                setIsButtonDisable(true);
                const response = await getAutoPopulateCoRFQDetailsForMMRFQApi({
                    coRFQId: coRFQId?.ID,
                    mmRFQId: params?.ID,
                    partId:
                        fromPath === "addPartnerForMMrfq"
                            ? params?.Part_Row_ID
                            : null
                });

                if (response?.status === true) {
                    response?.data[0]?.Part_Details?.forEach(
                        (item) =>
                            (item.selectedVendors = item?.selectedVendors || [])
                    );
                    response.data[0]["ID"] = response.data[0]?.ID || "-";
                    response.data[0]["Upload_Technical_File"] =
                        response.data[0]?.Upload_Technical_Details || "-";
                    response.data[0]["compliance"] =
                        response.data[0]?.Compliance_Requirements || "-";
                    response.data[0]["quality_standard"] =
                        response.data[0]?.Quality_Standards || "-";
                    response.data[0]["comments"] =
                        response.data[0]?.Add_Comments || "-";
                    let expiryDate = response?.data[0]?.Part_Details.filter(
                        (item) => item?.Part_Row_ID === params?.Part_Row_ID
                    );
                    response.data[0]["expiryDate"] =
                        expiryDate[0]?.expiryDate ?? "";
                    response.data[0]["previousExpiryDate"] =
                        expiryDate[0]?.expiryDate ?? "";

                    dispatch(setMmRfqFormData(response?.data));
                } else {
                    console.log("Something went wrong");
                }
            } catch (err) {
                console.log("API Error:", JSON.stringify(err));
            } finally {
                setIsButtonDisable(false);
            }
        };

        const handleMMRFQForm = async (fromPath) => {
            setIsLoading(true);
            await handleCallMMRFQApi(fromPath);
            navigate("/layout/MMRFQForm", {
                state: { from: fromPath, rfqData: coRFQId }
            });
            setIsLoading(false);
        };

        console.log("dataaa", getLoggedInName(), coRFQId.assigneeName);

        const handleSendReminderToSourcingHead = async () => {
            try {
                setIsButtonDisable(true);
                const payload = {
                    mmRfqID: params?.ID,
                    Company_RFQ: coRFQId?.ID,
                    Part_ID: params?.Part_Row_ID,
                    Entity: "Quote Approval Request Update",
                    Actor: getLoggedInUserID(),
                    ActorName: getLoggedInName()
                };
                const response = await sendReminderToSourcingHeadAPI(payload);

                if (response?.status === true) {
                    showToast({
                        message: `Reminder Sent to ${getLoggedInUserDepartment()} Head`,
                        type: "success"
                    });
                } else {
                    showToast({
                        message: `Send reminder failed`,
                        type: "error"
                    });
                }
            } catch (err) {
                showToast({
                    message: `Send reminder failed`,
                    type: "error"
                });
            } finally {
                setIsButtonDisable(false);
            }
        };

        return (
            <>
                {!isManagement()
                    ? params?.Status === "Pending" && (
                          <IconButton onClick={handleClick}>
                              <MoreVertIcon />
                          </IconButton>
                      )
                    : " "}
                <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                    {coRFQId?.assigneeName === getLoggedInName() ? (
                        <MenuItem sx={{ fontSize: "0.875rem" }}>
                            <Link
                                to={
                                    isDisabled ? "#" : "/layout/MenualQuotation"
                                }
                                style={{
                                    pointerEvents:
                                        isDisabled || isDropped
                                            ? "none"
                                            : "auto",
                                    textDecoration: "none",
                                    color:
                                        isDisabled || isDropped
                                            ? "#ccc"
                                            : "inherit"
                                }}
                                onClick={(e) => {
                                    if (isDisabled || isDropped)
                                        e.preventDefault();
                                }}
                                state={{
                                    rfqData: {
                                        ID: coRFQId?.ID,
                                        rfqID: coRFQId?.rfqID,
                                        mmRfqId: params?.MMRFQ_ID,
                                        mmRfqRowId: params?.ID,
                                        Part_Row_ID: params?.Part_Row_ID,
                                        assigneeName: coRFQId?.assigneeName
                                    },
                                    from: "AllMmrfq"
                                }}
                            >
                                Manually Enter Quote
                            </Link>
                        </MenuItem>
                    ) : null}

                    {(sourcingManager() &&
                        coRFQId?.assigneeName === getLoggedInName()) ||
                    true ? (
                        <MenuItem
                            // disabled={
                            //   (dueDateOnly && dueDateOnly < todayDateOnly) ||
                            //   isButtonDisable ||
                            //   (rfqEndDate && rfqEndDate < today)
                            // }
                            disabled={isDropped}
                            onClick={() =>
                                handleMMRFQForm("addPartnerForMMrfq")
                            }
                            sx={{ fontSize: "0.875rem" }}
                        >
                            Add a Partner
                        </MenuItem>
                    ) : null}

                    {(sourcingManager() ||
                        NPDManager() ||
                        productionManager()) && (
                        <MenuItem
                            onClick={handleSendReminderToSourcingHead}
                            sx={{ fontSize: "0.875rem" }}
                            disabled={
                                isDropped ||
                                params?.partnersReceived < 2 ||
                                isButtonDisable ||
                                rows[0]?.Is_Sent_To_Kam
                            }
                        >
                            Send Reminder to {getLoggedInUserDepartment()} Head
                        </MenuItem>
                    )}

                    {(sourcingManager() &&
                        coRFQId?.assigneeName === getLoggedInName()) ||
                    true ? (
                        <MenuItem
                            sx={{ fontSize: "0.875rem" }}
                            disabled={
                                isDropped ||
                                isButtonDisable ||
                                isManagement() ||
                                rows[0]?.Is_Sent_To_Kam
                            }
                            onClick={() =>
                                handleMMRFQForm("EditDueDateOfMMrfq")
                            }
                        >
                            Extend End Date
                        </MenuItem>
                    ) : null}
                </Menu>
            </>
        );
    };

    const finalColumns = columns;
    const handleSendToKamTrigger = async () => {
        setIsButtonDisable(true);

        try {
            const response = await sendToKamTriggerAPI({
                coRfqID: coRFQId?.ID,
                department: getLoggedInUserDepartment()
            });

            if (response?.status === true) {
                await fetchCustomerRfqData(coRFQId?.ID);

                showToast({
                    message: `Quotes shared with ${rows[0]?.Kam_Name}`,
                    type: "success"
                });
            } else {
                showToast({
                    message: `Failed To Send KAM.`,
                    type: "error"
                });
            }
        } catch (err) {
            showToast({
                message: `Failed To Send KAM.`,
                type: "error"
            });
        } finally {
            setIsButtonDisable(false);
        }
    };
    const parseDate = (dateStr) => {
        const monthNames = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ];
        if (!dateStr) return null;
        const [day, monthStr, year] = dateStr.split("-");
        const monthIndex = monthNames.indexOf(monthStr);
        return new Date(year, monthIndex, parseInt(day));
    };

    const dateTimeStr = rows[0]?.Ready_For_Proposal_Time || "";
    const [datePart, timePart] = dateTimeStr.split(" ");
    const formattedDate = datePart || "-";
    const formattedTime = timePart || "-";

    // add this above return (inside AllMmrfq component)
    const parentBreadcrumb =
        from === "Proposals"
            ? { to: "/layout/Proposals", label: "Proposals" }
            : from === "DroppedRfq"
              ? { to: "/layout/DroppedRfq", label: "Dropped CORFQs" }
              : { to: "/layout/CURFQAssignedToMe", label: "Assigned CORFQs" };

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: "10px" }}>
                <Typography sx={{ fontSize: "14px" }}>
                    <Link
                        to="/layout/Dashboard"
                        style={{
                            color: "#0070BA",
                            fontSize: "14px",
                            textDecoration: "none"
                        }}
                    >
                        Home
                    </Link>
                </Typography>

                <Typography sx={{ fontSize: "14px" }}>
                    <Link
                        to={parentBreadcrumb.to}
                        style={{
                            color: "#0070BA",
                            fontSize: "14px",
                            textDecoration: "none"
                        }}
                    >
                        {parentBreadcrumb.label}
                    </Link>
                </Typography>
                {[
                    <>
                        <Typography key="final" sx={{ fontSize: "14px" }}>
                            All MMRFQs
                        </Typography>
                    </>
                ]}
            </Breadcrumbs>
            <Typography variant="h5" mb={1}>
                All MMRFQs for {coRFQId?.rfqID}
            </Typography>

            {rows?.length > 0 && rows[0]?.Is_Sent_To_Kam === true && (
                <Alert severity="success" sx={{ marginBottom: "15px" }}>
                    The quotes for {coRFQId?.rfqID} have been submitted to the
                    KAM on {formattedDate}
                </Alert>
            )}
            {rows?.length > 0 &&
                // parseDate(rows[0]?.Rfq_End_Date) < new Date() &&
                rows[0]?.Is_Sent_To_Kam === false &&
                !isManagement() && (
                    <Alert severity="error" sx={{ marginBottom: "15px" }}>
                        The CORFQ end date is {rows[0]?.Rfq_End_Date}. Please
                        make sure you approve and reject partner(s) and submit
                        the quotes before the due date.
                    </Alert>
                )}
            <Box
                sx={{
                    borderRadius: "5px",
                    marginTop: "16px",
                    background: "#fff",
                    padding: "15px"
                }}
            >
                <Grid container spacing={2}>
                    {rows?.length >= 1 && (
                        <>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Grid container spacing={2} mb={2}>
                                    {/* Search Section */}
                                    <Grid size={{ xs: 12, md: 7 }}>
                                        <TextField
                                            label="Search by MMRFQ ID & Part Name"
                                            size="small"
                                            variant="outlined"
                                            fullWidth
                                            inputRef={searchInputRef}
                                            value={searchTerm}
                                            onChange={handleSearch}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            {(sourcingManagerHead() ||
                                productionManagerHead() ||
                                NPDManagerHead()) && (
                                <Grid size={{ xs: 12, md: 6 }}>
                                    {isAllPartQuoteApproved === false &&
                                        rows[0]?.Is_Sent_To_Kam === false && (
                                            <Tooltip title="All the Quotes of the Parts have to be either approved or rejected">
                                                <IconButton
                                                    sx={{ float: "right" }}
                                                >
                                                    <InfoOutlinedIcon
                                                        sx={{
                                                            width: "20px",
                                                            height: "20px"
                                                        }}
                                                    />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    {rows[0]?.Is_Sent_To_Kam === false && (
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            sx={{ float: "right" }}
                                            disabled={
                                                isAllPartQuoteApproved ===
                                                    false ||
                                                isButtonDisable ||
                                                rows[0]?.Is_Sent_To_Kam ||
                                                isDropped
                                                //  ||
                                                // parseDate(rows[0]?.Rfq_End_Date) < new Date()
                                            }
                                            onClick={handleSendToKamTrigger}
                                        >
                                            {!isButtonDisable
                                                ? "SEND TO KAM"
                                                : "Sending"}
                                        </Button>
                                    )}
                                </Grid>
                            )}
                        </>
                    )}
                </Grid>

                <Paper
                    sx={{
                        height:
                            filteredRows?.length > 4
                                ? "62vh"
                                : filteredRows?.length > 0
                                  ? "auto"
                                  : "62vh" // width: "100%",
                    }}
                >
                    {!isLoading ? (
                        filteredRows?.length > 0 ? (
                            <DataGridPro
                                pinnedColumns={pinnedColumns}
                                onPinnedColumnsChange={
                                    handlePinnedColumnsChange
                                }
                                getRowHeight={() => "auto"}
                                rows={filteredRows}
                                columns={finalColumns}
                                pagination={filteredRows?.length > 10}
                                paginationModel={paginationModel}
                                onPaginationModelChange={setPaginationModel}
                                pageSizeOptions={[10, 20]}
                                disableRowSelectionOnClick={true}
                                sortModel={[
                                    {
                                        field: "MMRFQ_ID",
                                        sort: "asc"
                                    }
                                ]}
                                sx={{
                                    width: "100%",
                                    "& .MuiDataGrid-columnHeaderTitleContainer":
                                        {
                                            "& .MuiDataGrid-sortIcon": {
                                                opacity: "1 !important",
                                                visibility: "visible !important"
                                            }
                                        },
                                    "& .MuiDataGrid-cell": {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    "& .MuiDataGrid-scrollbarFiller--pinnedRight":
                                        {
                                            backgroundColor: "#F4F4F4!important"
                                        }
                                }}
                            />
                        ) : (
                            <>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: "8px",
                                        padding: "20px"
                                    }}
                                >
                                    {searchTerm && filteredRows?.length == 0 ? (
                                        "No Options available"
                                    ) : (
                                        <>
                                            <img
                                                src={emptyImage}
                                                alt="Empty"
                                                width={"300px"}
                                            />
                                            <b style={{ color: "#0009" }}>
                                                No RFQs Captured yet
                                            </b>
                                        </>
                                    )}
                                </div>
                            </>
                        )
                    ) : (
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="50vh"
                        >
                            <ThreeDot
                                color="#1976d2"
                                size="medium"
                                text=""
                                textColor=""
                            />
                        </Box>
                    )}
                </Paper>
                <PartnerDetailsDrawer
                    open={openDrawer}
                    onClose={handleCloseDrawer}
                    selectedPartner={selectedPartnerRow}
                />
                <Drawer
                    anchor="right"
                    open={drawerOpen}
                    onClose={() => setDrawerOpen(false)}
                >
                    {selectedQuoteId && (
                        <QuoteDrawer
                            open={drawerOpen}
                            onClose={() => setDrawerOpen(false)}
                            quoteId={selectedQuoteId}
                        />
                    )}
                </Drawer>
            </Box>
        </>
    );
};
